import React from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import DateTimePicker from '@/components/Form/DateTimePicker'
interface Props {
    control: Control<any>
}

const TicketTimeRelease: React.FC<Props> = ({ control }) => {
    const { t } = useTranslation()
    return (
        <>
            <DateTimePicker
                control={control}
                name="ticket_time_release"
                label={t('ticket-date-completed')}
                required
            />
        </>
    )
}

export default TicketTimeRelease
